import { useFilterTransactionWaiverContext } from "./filter-transaction-waiver.context";

export function FilterTransactionWaiver() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterTransactionWaiverContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}